import { 
    SET_IMAGE_FILE,
    SET_IMAGES_FILE,
    DELETE_IMAGE_ARRAY,
    CLEAR_IMAGE,
 } from '../types';

const initialState = {
    imageUrl : '',
    images: [],
}

export default function(state = initialState, action) {
    switch(action.type){
        case SET_IMAGE_FILE:
            return {
                ...state,
                imageUrl: action.imageUrl,
            };
        case SET_IMAGES_FILE:
            state.images.push({
                image: action.imageUrl
            })
            return {...state};
        case DELETE_IMAGE_ARRAY:
            state.images.splice(action.index, 1);
            return {...state};
        case CLEAR_IMAGE: 
            return {
                imageUrl : '',
                images: [],
            }
        default:
            return state;
    }
}